//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  input: {
    '&:checked + $container': {
      borderColor: colors.primary,
    },
    '&:checked + $container $customCheckbox': {
      border: `6px solid ${colors.primary}`,
    },
    '&:checked + $container $label': {
      color: colors.grey900,
    },
    '&:checked + $container $description': {
      color: colors.grey800,
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    cursor: 'pointer',
    padding: '.75rem',
    borderRadius: '.75rem',
    border: `1px solid ${colors.grey400}`,

    '&[data-disabled=true]': {
      cursor: 'not-allowed',
    },

    '&:hover': {
      borderColor: colors.primary,
    },
  },
  customCheckbox: {
    borderRadius: '50%',
    minWidth: '1.5rem',
    minHeight: '1.5rem',
    width: '1.5rem',
    height: '1.5rem',
    border: `1.25px solid ${colors.grey400}`,
    background: 'white',
    transition: 'border .2s ease-in-out',
  },
  label: {
    fontSize: '.875rem',
    color: colors.grey700,
    fontWeight: 600,
  },
  description: {
    fontSize: '.875rem',
    color: colors.grey700,
  },
}));

type Props = {
  defaultChecked?: boolean,
  name: string,
  label: string,
  onChange?: (checked: boolean) => void,
  checked?: boolean,
  inputProps?: Object,
  labelContainerProps?: Object,
  description?: string,
  id?: string,
  disabled?: boolean,
};

export default function TiendadaRadioButton(props: Props) {
  const {
    defaultChecked,
    label,
    name,
    id,
    onChange,
    checked,
    inputProps,
    labelContainerProps,
    description,
    disabled,
  } = props;

  const classes = useStyles();

  const handleChange = e => {
    onChange && onChange(e.target.checked);
  };

  return (
    <>
      <input
        type="radio"
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={handleChange}
        hidden
        className={classes.input}
        id={label ?? id}
        name={name}
        disabled={disabled}
        {...inputProps}
      />
      <label
        {...labelContainerProps}
        className={classes.container}
        data-disabled={disabled}
        htmlFor={label ?? id}
      >
        <span className={classes.customCheckbox} />
        <div className={classes.content}>
          <span className={classes.label}>{label}</span>
          {description && (
            <Typography className={classes.description}>
              {description}
            </Typography>
          )}
        </div>
      </label>
    </>
  );
}
